import z from "zod";
import { ACCOUNT_NAME_REGEX, InvalidFormatMessage, RESERVED_NAMES, RESERVED_PREFIXES_REGEX, InvalidAccountMessage, ACCOUNT_DESC_REGEX } from "@/shared/constants/validation";

export const NAME_MAX_LENGTH = 50;

export const walletAddressSchema = z.object({
  name: z.string()
    .min(1, "error.name.required")
    .max(NAME_MAX_LENGTH, "error.name.max"),
  address: z.string()
    .min(1, "error.address.required"),
  threshold: z.string()
    .min(1, "error.threshold.required")
    .refine((val) => !Number.isNaN(Number(val)) && Number(val) > 0, {
      message: "error.threshold.positive",
    }),
});

export const createAccountSchema = z.object({
  name: z.string()
    .regex(ACCOUNT_NAME_REGEX, InvalidFormatMessage)
    .min(3)
    .max(50)
    .refine((v) => {
      const isValid = !RESERVED_NAMES.includes(v) && !RESERVED_PREFIXES_REGEX.test(v);
      return isValid;
    }, InvalidAccountMessage),
  about: z.string()
    .regex(ACCOUNT_DESC_REGEX, InvalidFormatMessage)
    .min(0)
    .max(64).optional(),
});

export type WalletAddressValidationSchema = z.infer<typeof walletAddressSchema>;
export type CreateAccountValidationSchema = z.infer<typeof createAccountSchema>;